export default class ContactsService {
  static $inject = ['$http'];

  baseUrl = '/aptitude/api/contacts/';

  constructor(private $http) {
    'ngInject';
  }

  addContact(contact: any): ng.IPromise<any> {
    return this.$http.post(this.baseUrl, contact);
  }

  updateContact(id: number, contact: any): ng.IPromise<any> {
    return this.$http.put(`${this.baseUrl}${id}`, contact);
  }
}
